export const LOCATIONS = ["BANJARAHILLS", "UPPAL", "TRIMULGHERRY", "MIYAPUR"]
